import Button from '@components/common/button';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import Typography from '@components/common/typography';
import { Icon } from '@components/icons';
import { useUserContext } from '@hooks/context/useUserContext';
import { routes } from '@const/routes';
import { useNavigate } from 'react-router-dom';
import { useVerificationGuard } from '@hooks/helpers/useVerificationGuard';
import Skeleton from '@components/common/skeleton';
import Cashback from '@sections/dashboard/cashback';
import LoyaltySection from '@sections/dashboard/loyalty';
import { prettifyStars } from '@utils/index';

const AccountsSection = () => {
    const { t } = useTranslation('sections', {
        keyPrefix: 'dashboard.accounts'
    });
    const navigate = useNavigate();
    const { account, isDataLoading } = useUserContext();
    const { verifiedAction } = useVerificationGuard();

    const handleOpenModal = () => {
        verifiedAction(() => navigate(routes.link_card_bank));
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.accounts}>
                <Typography className={styles.title} variant="body1" weight="bold">
                    {t('title')}
                </Typography>
                {isDataLoading && <Skeleton className={styles.account_skeleton} />}
                {!!account?.bank_accounts.length && (
                    <ul className={styles.accounts_list}>
                        {account?.bank_accounts.map((item) => (
                            <li
                                key={item.id}
                                className={styles.account_item}
                                onClick={() => navigate(`${routes.manage_accounts}?id=${item.id}`)}>
                                <Icon name="filled_bank" />
                                <div className={styles.text_wrapper}>
                                    <Typography className={styles.title} variant="body3">
                                        {item.institution_name}
                                    </Typography>
                                    <Typography
                                        className={styles.description}
                                        variant="body3"
                                        fz={14}>
                                        {item.account_name} {prettifyStars(item.account_number)}
                                    </Typography>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                {/*TEMP-HIDE EPS (founder 2026-06-29) — restore to re-enable*/}
                {/*{!!account?.eps_cards.length && (
                    <ul className={styles.accounts_list}>
                        {account?.eps_cards.map((item) => (
                            <li
                                key={item.id}
                                className={styles.account_item}
                                onClick={() => navigate(`${routes.manage_accounts}?id=${item.id}`)}>
                                <Icon name="filled_card" />
                                <div className={styles.text_wrapper}>
                                    <Typography variant="body3" className={styles.title}>
                                        {item.card_holder_name}
                                    </Typography>
                                    <Typography
                                        className={styles.description}
                                        variant="body3"
                                        fz={14}>
                                        {item.card_brand} {prettifyCardStars(item.card_number)}
                                    </Typography>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}*/}
                <Button className={styles.add_card} onClick={handleOpenModal}>
                    <Button variant="icon-gray" size="small">
                        <Icon name="plus" />
                    </Button>
                    <Typography variant="body3">{t('link_new')}</Typography>
                </Button>
            </div>
            <LoyaltySection />
            <Cashback />
        </div>
    );
};

export default AccountsSection;
